import { withStatus } from 'hoc/Status/Status';
import Component, { EditBankFormProps } from 'components/EditBankForm/EditBankForm';

const EditBankForm = withStatus<EditBankFormProps>(Component);

export default EditBankForm
